import { Locale as LocaleString } from "@shared/types";
import { Locale } from "date-fns/locale";

interface Weight {
  g: string;
  oz: string;
  lb: string;
  kg: string;
}
const GRAM_CONVERSION_VALUES = {
  g: 1,
  oz: 0.03527,
  lb: 0.0022046,
  kg: 0.001,
};

const IMPERIAL_GRAM_MAX = 350;
const METRIC_GRAM_MAX = 800;

export const formatIntlWeight = (
  value: number | string | undefined,
  format: string,
  locale: Locale,
  resource: { translation: object },
  lng: LocaleString
) => {
  const translation: { weight?: { [key: string]: string } } = resource.translation;
  let gramValue = Number(value ?? 0);
  if (Number.isNaN(gramValue)) gramValue = 0;

  const weight = {
    g: new Intl.NumberFormat(locale.code, { maximumSignificantDigits: 3 }).format(gramValue),
    oz: new Intl.NumberFormat(locale.code, { maximumSignificantDigits: 3 }).format(gramValue * GRAM_CONVERSION_VALUES["oz"]),
    lb: new Intl.NumberFormat(locale.code, { maximumSignificantDigits: 3 }).format(gramValue * GRAM_CONVERSION_VALUES["lb"]),
    kg: new Intl.NumberFormat(locale.code, { maximumSignificantDigits: 3 }).format(gramValue * GRAM_CONVERSION_VALUES["kg"]),
  };
  return (
    (format === "weightValue" && returnWeightValue(gramValue, weight, lng)) ||
    (format === "weightSuffix" && returnWeightSuffix(gramValue, weight, lng)) ||
    (format === "weightUnit" && returnWeightUnit(gramValue, translation, lng)) ||
    returnWeightString(gramValue, weight, lng)
  );
};

const returnWeightString = (value: number, weight: Weight, lng: LocaleString) => {
  return (
    (lng === "en_US" && value > IMPERIAL_GRAM_MAX && `${weight["lb"]} lb`) ||
    (value > METRIC_GRAM_MAX && `${weight["kg"]} kg`) ||
    (lng === "en_US" && `${weight["oz"]} oz`) ||
    `${weight["g"]} g`
  );
};
const returnWeightValue = (value: number, weight: Weight, lng: LocaleString) => {
  return (
    (lng === "en_US" && value > IMPERIAL_GRAM_MAX && weight["lb"]) ||
    (lng === "en_US" && weight["oz"]) ||
    (value > METRIC_GRAM_MAX && weight["kg"]) ||
    weight["g"]
  );
};
const returnWeightSuffix = (value: number, weight: Weight, lng: LocaleString) => {
  return (lng === "en_US" && value > IMPERIAL_GRAM_MAX && "lb") || (value > METRIC_GRAM_MAX && "kg") || (lng === "en_US" && "oz") || "g";
};
const returnWeightUnit = (value: number, translation: { weight?: { [key: string]: string } }, lng: LocaleString) => {
  const t = translation.weight ?? {};
  if (lng === "en_US" && value > IMPERIAL_GRAM_MAX && t.pounds) {
    return t.pounds;
  } else if (value > METRIC_GRAM_MAX) {
    return t.kilograms ?? "Kilograms";
  } else if (lng === "en_US") {
    return t.ounces ?? "Ounces";
  } else {
    return t.grams ?? "Grams";
  }
};
